
import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Container } from "react-bootstrap";
import { Row, Col, Image, Spin, Button, Alert } from "antd";

const API_URL =
    "https://api.github.com/repos/VuongMinh01/MinMedia-anh/contents/PPSC/PPSC3";

const PAGE_SIZE = 24;

export default function PPSC03() {
    const [imageList, setImageList] = useState([]);
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const controller = new AbortController();

        async function fetchImages() {
            try {
                setLoading(true);
                setError("");

                // GitHub Contents API: tối đa 100 file mỗi request
                const firstResponse = await fetch(
                    `${API_URL}?per_page=100&page=1`,
                    { signal: controller.signal }
                );

                if (!firstResponse.ok) {
                    throw new Error(`GitHub API trả về lỗi ${firstResponse.status}`);
                }

                const firstPage = await firstResponse.json();

                if (!Array.isArray(firstPage)) {
                    throw new Error("Không lấy được danh sách ảnh từ GitHub.");
                }

                let files = [...firstPage];

                // Nếu có đủ 100 mục, kiểm tra trang tiếp theo
                if (firstPage.length === 100) {
                    const secondResponse = await fetch(
                        `${API_URL}?per_page=100&page=2`,
                        { signal: controller.signal }
                    );

                    if (!secondResponse.ok) {
                        throw new Error(
                            `Không tải được trang ảnh tiếp theo: ${secondResponse.status}`
                        );
                    }

                    const secondPage = await secondResponse.json();

                    if (Array.isArray(secondPage)) {
                        files = files.concat(secondPage);
                    }
                }

                const urls = files
                    .filter(
                        (file) =>
                            file.type === "file" &&
                            /\.(jpg|jpeg|png|webp)$/i.test(file.name)
                    )
                    .map((file) => ({
                        name: file.name,
                        url: file.download_url,
                    }))
                    .filter((file) => file.url);

                if (!controller.signal.aborted) {
                    setImageList(urls);
                    setVisibleCount(PAGE_SIZE);
                }
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Lỗi tải album:", err);
                    setError(err.message || "Không thể tải album ảnh.");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        }

        fetchImages();

        return () => controller.abort();
    }, []);

    return (
        <Container fluid>
            <Header />

            <div style={{ minHeight: "60vh", padding: "20px 0" }}>
                {loading ? (
                    <div style={{ textAlign: "center", padding: 50 }}>
                        <Spin size="large" tip="Đang tải album ảnh..." />
                    </div>
                ) : error ? (
                    <Alert type="error" showIcon message={error} />
                ) : imageList.length === 0 ? (
                    <Alert
                        type="info"
                        showIcon
                        message="Chưa tìm thấy ảnh trong album."
                    />
                ) : (
                    <>
                        <p style={{ textAlign: "center", marginBottom: 20 }}>
                            Đang hiển thị {Math.min(visibleCount, imageList.length)} /{" "}
                            {imageList.length} ảnh
                        </p>

                        <Image.PreviewGroup>
                            <Row gutter={[12, 12]}>
                                {imageList.slice(0, visibleCount).map((image, idx) => (
                                    <Col xs={12} sm={8} md={6} lg={4} key={image.name}>
                                        <Image
                                            src={image.url}
                                            alt={image.name}
                                            width="100%"
                                            height={220}
                                            loading="lazy"
                                            decoding="async"
                                            style={{
                                                display: "block",
                                                padding: 3,
                                                objectFit: "cover",
                                                borderRadius: 8,
                                            }}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Image.PreviewGroup>

                        {visibleCount < imageList.length && (
                            <div style={{ textAlign: "center", margin: "28px 0" }}>
                                <Button
                                    type="primary"
                                    size="large"
                                    onClick={() =>
                                        setVisibleCount((count) =>
                                            Math.min(count + PAGE_SIZE, imageList.length)
                                        )
                                    }
                                >
                                    Xem thêm ảnh (
                                    {imageList.length - visibleCount} ảnh còn lại)
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </div>

            <Footer />
        </Container>
    );
}
